/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  PresenterCreateOfficeRequest,
  PresenterMFIDSessionResponse,
  PresenterOneCreatableOfficeResponse,
  PresenterOneOfficeResponse,
  PresenterResponse,
  PresenterSwitchOfficeRequest,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Offices<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * @description creatable offices
   *
   * @tags offices
   * @name GetCreatableOffices
   * @summary Get creatable offices
   * @request GET:/creatable_offices
   */
  getCreatableOffices = (params: RequestParams = {}) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterOneCreatableOfficeResponse[];
      },
      any
    >({
      path: `/creatable_offices`,
      method: "GET",
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get office list
   *
   * @tags offices
   * @name GetOffices
   * @summary Get office list
   * @request GET:/offices
   */
  getOffices = (params: RequestParams = {}) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterOneOfficeResponse[];
      },
      any
    >({
      path: `/offices`,
      method: "GET",
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Create an office from Navis tenantID
   *
   * @tags offices
   * @name PostOffices
   * @summary Create an office from Navis tenant
   * @request POST:/offices
   */
  postOffices = (
    body: PresenterCreateOfficeRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterMFIDSessionResponse;
      },
      any
    >({
      path: `/offices`,
      method: "POST",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Switch office in JWT
   *
   * @tags offices
   * @name PutOfficesSwitch
   * @summary Switch Office
   * @request PUT:/offices/switch
   */
  putOfficesSwitch = (
    body: PresenterSwitchOfficeRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterMFIDSessionResponse;
      },
      any
    >({
      path: `/offices/switch`,
      method: "PUT",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Sync & Get office list
   *
   * @tags offices
   * @name GetOfficesSync
   * @summary Synchronize offices from Navis and Get office list
   * @request GET:/offices/sync
   */
  getOfficesSync = (params: RequestParams = {}) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterOneOfficeResponse[];
      },
      any
    >({
      path: `/offices/sync`,
      method: "GET",
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
